import { exhaustiveCheck } from "@lib/exhaustiveCheck";
import type { ContentGenerationMessageType } from "@lib/generativeAi";

import type { ContentOptimizationChannel, EmailComponentName, PushComponentName, SmsComponentName } from "./types";

const defaultContentGenerationMessageType: ContentGenerationMessageType = "push notification title";

export const mapComponentNameToMessageType = (
  componentName?: string | null,
  channel?: ContentOptimizationChannel
): ContentGenerationMessageType => {
  if (componentName && channel) {
    switch (channel) {
      case "email": {
        const emailComponentName = componentName as EmailComponentName;
        switch (emailComponentName) {
          case "Subject":
            return "email subject line";
          case "Preheader":
            return "email preheader";
          case "Sender Name":
            return "email sender name";
          case "Body Header":
            return "email body header";
          case "Body Content":
            return "email body";
          case "Primary CTA":
            return "email primary call-to-action";
          case "Image":
            // Image is not generated via VariantGenerationAssistant; use the shared default.
            break;
          default:
            exhaustiveCheck(emailComponentName);
            break;
        }
        break;
      }
      case "push": {
        const pushComponentName = componentName as PushComponentName;
        switch (pushComponentName) {
          case "Title":
            return "push notification title";
          case "Message":
            return "push notification";
          case "Image":
            // Image is not generated via VariantGenerationAssistant; use the shared default.
            break;
          default:
            exhaustiveCheck(pushComponentName);
            break;
        }
        break;
      }
      case "sms": {
        const smsComponentName = componentName as SmsComponentName;
        switch (smsComponentName) {
          case "Hook":
            return "SMS hook";
          case "Body":
            return "SMS body";
          case "CTA":
            return "SMS call-to-action";
          case "Image":
            // Image is not generated via VariantGenerationAssistant; use the shared default.
            break;
          default:
            exhaustiveCheck(smsComponentName);
            break;
        }
        break;
      }
      default:
        exhaustiveCheck(channel);
        break;
    }
  }
  // default in case an incorrectly casted value is supplied
  return defaultContentGenerationMessageType;
};
